import { render, staticRenderFns } from "./IndividualTest.vue?vue&type=template&id=fcbccd24&scoped=true"
import script from "./IndividualTest.vue?vue&type=script&lang=js"
export * from "./IndividualTest.vue?vue&type=script&lang=js"
import style0 from "./IndividualTest.vue?vue&type=style&index=0&id=fcbccd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbccd24",
  null
  
)

export default component.exports